import { title } from "framer-motion/client";

export const COURSES_CATEGORIES = [
    'Gestión y Administracion',
    'Desarrollo Personal y Profesional',
    'Salud y Bienestar',
    'Programación y Tecnologías de la Información',
    'Contabilidad e Impuestos',
    'Salud y Farmacia',
    'Juridico y Notarial',
    'Relaciones Públicas y Marketing',
    'Estética y Bienestar',
    'Turismo',
    'Diplomaturas y Formación Especializada',
    'Deportes',
    'Comercio Exterior y Relaciones Internacionales',
    'Recursos Humanos',
    'Programa de Impulso Profesional'
];

export const COURSES_PROGRAMMING = [
    'Programación Basica en Python',
    'Análisis de Datos con Python',
    'Desarrollo Web con Html, Css y Javascript',
    'Diseño de Bases de Datos con SQL',
    'Microsoft Excel - Nivel Inicial',
    'Introdduccion a la programación'
]

export const COURSES_PHARMACY = [
    'Asistente de Farmacia con Liquidación de Obras Sociales',
    'Asistente de Farmacia Hospitalaria y Centros Asistenciales',
    'Auxiliar Superior en Gestión Farmaceutica',
    'Prestaciones Médicas con Facturación y manejo de Nomenclador Nacional',
    'Capacitación en Auditoria Médica Administrativa',
]

export const MODES_FOOTER = [
    '100% Online',
    'Clases en Vivo',
    'Diplomados',
    'Secretariados'
]

export const GESTAR_NAV = [
    'CURSOS',
    'DIPLOMADOS',
    'SECRETARIADOS',
    'EMPRESAS',
    'COMUNIDAD',
    'SOBRE NOSOTROS'
]

export const CONTACT_DATA = [
    'Sede Central',
    '+54 9 11 6267-6211',
    'Av. de mayo 847, 1er piso',
    'CABA, Bs.As.',
]

export const discountItems = [
  {
    id: 1,
    title: "20% DESCUENTO",
    date: "xx/xx/xxxx",
    image: "https://via.placeholder.com/100",
  },
  {
    id: 2,
    title: "20% DESCUENTO",
    date: "xx/xx/xxxx",
    image: "https://via.placeholder.com/100",
  },
  {
    id: 3,
    title: "20% DESCUENTO",
    date: "xx/xx/xxxx",
    image: "https://via.placeholder.com/100",
  },
  {
    id: 4,
    title: "20% DESCUENTO",
    date: "xx/xx/xxxx",
    image: "https://via.placeholder.com/100",
  },
  {
    id: 5,
    title: "20% DESCUENTO",
    date: "xx/xx/xxxx",
    image: "https://via.placeholder.com/100",
  },
  {
    id: 6,
    title: "20% DESCUENTO",
    date: "xx/xx/xxxx",
    image: "https://via.placeholder.com/100",
  },
  {
    id: 7,
    title: "20% DESCUENTO",
    date: "xx/xx/xxxx",
    image: "https://via.placeholder.com/100",
  },
  {
    id: 8,
    title: "20% DESCUENTO",
    date: "xx/xx/xxxx",
    image: "https://via.placeholder.com/100",
  },
];

export const inspiredItems = [
  {
    title: "CONOCIMIENTO",
    description: `La capacitación y el conocimiento juegan un papel
          protagónico para el crecimiento de las
          organizaciones, como motor de desarrollo
          productivo, social y cultural.
          ACOMPAÑAMOS Y PROMOVEMOS ESTOS
          PROCESOS DE TRANSFORMACIÓN A TRAVÉS DE
          LA FORMACIÓN PROFESIONAL.`,
  },
  {
    title: "EXPERIENCIA PERSONALIZADA",
    description: `DISEÑAMOS CIRCUITOS ADMINISTRATIVOS Y
          PEDAGÓGICOS PARA CONTENER AL ALUMNO EN
          TODO SU TRAYECTO DE APRENDIZAJE.
          Desde nuestro innovador Campus virtual, brindamos
          atención permanente y personalizada, soporte técnico y
          administrativo, y seguimiento al alumno por parte de todo
          el equipo de Docentes.`,
  },
  {
    title: "CALIDAD",
    description: `DISEÑAMOS CIRCUITOS ADMINISTRATIVOS Y
            PEDAGÓGICOS PARA CONTENER AL ALUMNO EN
            TODO SU TRAYECTO DE APRENDIZAJE.
            Desde nuestro innovador Campus virtual, brindamos
            atención permanente y personalizada, soporte técnico y
            administrativo, y seguimiento al alumno por parte de todo
            el equipo de Docentes.`,
  },
  {
    title: "OPORTUNIDAD DE CRECIMIENTO",
    description: `DISEÑAMOS CIRCUITOS ADMINISTRATIVOS Y
            PEDAGÓGICOS PARA CONTENER AL ALUMNO EN
            TODO SU TRAYECTO DE APRENDIZAJE.
            Desde nuestro innovador Campus virtual, brindamos
            atención permanente y personalizada, soporte técnico y
            administrativo, y seguimiento al alumno por parte de todo
            el equipo de Docentes.`,
  },
];

export const ABOUT_US_DESCRIPTIONS = {
  mission: `Queremos ser protagonistas, impulsores y facilitadores de los procesos de transformación de las personas, organizaciones y sociedades, a través de la formación continua de calidad, con innovación en el aprendizaje y compromiso con el futuro.

`,
  vision: `Ser líderes en Argentina y Latinoamérica en formación profesional y capacitación, en diversas habilidades y competencias para la transformación, y el desarrollo actual y potencial de individuos y organizaciones.

`,
  values: `Innovación, inclusión y empleabilidad, diversidad, calidad de aprendizaje.

`,
}